import { computed } from "vue";
import { useConfig } from "./config";
export function useStorageLocationConfiguration() {
    const { config } = useConfig();
    const isOnlyPreference = computed(() => {
        var _a;
        return !config.value || !((_a = config.value) === null || _a === void 0 ? void 0 : _a.object_store_always_respect_user_selection);
    });
    return {
        isOnlyPreference,
    };
}
